import React from 'react';
import TextElement from './text-element';
import SplitContentBox from './split-content-box';
import '../css/content-box.less';

export default ({ leftContent, rightContent,  bottomContent=[], disclaimers=[] }) => {
    return(
        <div className='custom-component content-box'>
            <SplitContentBox leftContent={leftContent} rightContent={rightContent} disclaimers={disclaimers}/>
            {bottomContent.map((element, i) => <TextElement key={`content-box-text-${i}`} disclaimers={disclaimers} {...element}/>)}
        </div>
    )
}
